import React from 'react';

import PageEditForm from './PageEditForm';
import { Page } from '../../../Data/Classes';

function PageCreatePage(props) {
    const page = new Page(0, "", "", 0, "", false);

    return (
        <>
            <h1>Lap létrehozása</h1>
            <PageEditForm page={page} />
        </>
    );
}

export default PageCreatePage;
